export const iconFontAwesomeEnergyExplosion = (
	<i className="fa-solid fa-explosion"></i>
);
